var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedqueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26,
    viewBox: "0 0 40.314 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4879 19914)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 36,
    rx: 2,
    transform: "translate(-4879 -19914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,13.585,13.585,9.8m-1.353,7.126L1.984,6.674A3.79,3.79,0,0,1,.948,4.739L0,0,4.738.948A3.789,3.789,0,0,1,6.674,1.984L16.922,12.232a3.317,3.317,0,0,1-4.691,4.691Z",
    transform: "translate(-4857.33 -19887.053) rotate(-90)",
    fill: "#fff",
    stroke: "#008bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x2: 20.551,
    transform: "translate(-4874.072 -19907.303)",
    fill: "none",
    stroke: "#008bff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 14.386,
    transform: "translate(-4874.072 -19897.027)",
    fill: "none",
    stroke: "#008bff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 10.276,
    transform: "translate(-4874.072 -19886.752)",
    fill: "none",
    stroke: "#008bff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedqueries);
export default __webpack_public_path__ + "static/media/advanced queries.18b44d7c5537bcfcfd3f11525aa25d5c.svg";
export { ForwardRef as ReactComponent };